import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class CustomerGroupResource extends BaseCamelCasedResource {
    pk() {
        return this.customerId?.toString() || "";
    }
}
CustomerGroupResource.urlRoot = apiResourceUrl("customer-group");
//# sourceMappingURL=CustomerGroupResource.js.map